import React from 'react';
import { isEqual } from 'lodash';

import { useDispatch, useSelector } from '../../redux/hooks';
import { selectMarketFilters, setMarketFilters } from '../../redux/actions/market';
import { fetchTenantProfile, selectTenantProfile } from '../../redux/actions/tenants';
import { fetchSettableMetadataForOrder, selectSettableMetadataForOrder } from '../../redux/actions/metadata';
import { getDefaultFulfilsProfile } from '../../utils/metadata';

/** The company profile's requirement ids for carriers, null until loaded (loads them when missing). */
export function useProfileRequirementIds() {
    const dispatch = useDispatch();
    const tenantProfile = useSelector(selectTenantProfile());
    const settableMetadata = useSelector(selectSettableMetadataForOrder());
    const hasMetadataOptions = !!settableMetadata.vehicleTypeOptions;

    React.useEffect(() => {
        if (!tenantProfile) {
            dispatch(fetchTenantProfile());
        }
        if (!hasMetadataOptions) {
            dispatch(fetchSettableMetadataForOrder());
        }
    }, [dispatch, tenantProfile, hasMetadataOptions]);

    return React.useMemo(
        () => getDefaultFulfilsProfile(tenantProfile, settableMetadata),
        [tenantProfile, settableMetadata]
    );
}

/** For carriers, keeps fulfilsProfile in sync with the profile's requirement ids unless "Alla uppdrag" was chosen. */
export default function useDefaultFulfilsProfile() {
    const dispatch = useDispatch();
    const { showAllAssignments, fulfilsProfile } = useSelector(selectMarketFilters());
    const ids = useProfileRequirementIds();

    React.useEffect(() => {
        if (!ids || showAllAssignments) return;
        if (!isEqual(ids, fulfilsProfile)) {
            dispatch(setMarketFilters({ fulfilsProfile: ids }));
        }
    }, [dispatch, ids, showAllAssignments, fulfilsProfile]);
}
